import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@node-space/ui-components'
import { ConfirmationOfPayeeCalloutType, ConfirmationOfPayeeCalloutTypes } from '../types'

const CTA_TEXT_MAPPING: Record<ConfirmationOfPayeeCalloutType, string> = {
  [ConfirmationOfPayeeCalloutTypes.BENEFICIARY_PAYOUT]:
    'wallets.fiatSend.verificationOfPayee.updateThisBeneficiary',
  [ConfirmationOfPayeeCalloutTypes.BANK_ACCOUNT_PAYOUT]:
    'wallets.fiatSend.verificationOfPayee.updateThisBankAccount',
  [ConfirmationOfPayeeCalloutTypes.BENEFICIARY]: 'manageBeneficiaries.reviewBeneficiaryDetails',
  [ConfirmationOfPayeeCalloutTypes.BANK_ACCOUNT]: 'manageBeneficiaries.reviewBankAccountDetails',
}

interface ConfirmationOfPayeeCalloutCtaProps {
  type: ConfirmationOfPayeeCalloutType
  handleEditBankAccount?: () => void
}

export const ConfirmationOfPayeeCalloutCta = ({
  type,
  handleEditBankAccount,
}: ConfirmationOfPayeeCalloutCtaProps) => {
  const { t } = useTranslation()

  if (!type || !handleEditBankAccount) return

  const textKey = CTA_TEXT_MAPPING[type]

  if (!textKey) return

  return (
    <Button variant="ghost" noPadding onClick={handleEditBankAccount}>
      {t(textKey)}
    </Button>
  )
}
